<template>
  <div v-html="userAlert.msg" :class="cssClass" class="text-center py-1 px-4" />
</template>
<script>
export default {
  props: ["userAlert"],
  computed: {
    cssClass() {
      const type = this.userAlert.type;
      if (type == "issues") {
        return "bg-red-100 border-red-200 text-red-800 border-b";
      }
      if (type == "info") {
        return "bg-blue-100 border-blue-200 text-blue-800 border-b";
      }
      if (type == "success") {
        return "bg-green-100 border-green-200 text-green-800 border-b";
      }
      console.log(type);
      return "bg-blacko-70 text-white";
    },
  },
};
</script>
